/**
 * Generate & return the SSO link.
 */
export const getSiteLink = async ($api, siteId) => {
  const { data } = await $api.get(`/api/v2/sites/${siteId}/sso`)

  return data
}
